var _circle, _g, _circle2, _g2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrueIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4334_40995)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4334_40995",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 12,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4334_40995)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 12,
    fill: "#E32227"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4334_40995)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4334_40995",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 12,
    fill: "#010101"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4334_40995)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0143 15.8766L19.918 15.8745V16.2724H19.8594V15.8745H19.7065V15.8242H20.0667V15.8305C20.0667 15.8619 20.0499 15.8766 20.0143 15.8766Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9181 16.2813H19.8595C19.8553 16.2813 19.8511 16.2771 19.8511 16.2729V15.8834H19.7066C19.7024 15.8834 19.6982 15.8792 19.6982 15.875V15.8248C19.6982 15.8206 19.7024 15.8164 19.7066 15.8164H20.0667C20.0709 15.8164 20.0751 15.8206 20.0751 15.8248V15.8311C20.0751 15.8562 20.0646 15.8855 20.0144 15.8855L19.9265 15.8834V16.2729C19.9265 16.2771 19.9223 16.2813 19.9181 16.2813ZM19.8678 16.2645H19.9097V15.875C19.9097 15.8729 19.9097 15.8709 19.9118 15.8688C19.9139 15.8667 19.916 15.8646 19.9181 15.8667L20.0144 15.8688C20.05 15.8688 20.0584 15.852 20.0584 15.8353H19.7171V15.8667H19.8595C19.8636 15.8667 19.8678 15.8709 19.8678 15.875V16.2645Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5081 16.2724V15.8996H20.506L20.3657 16.2724H20.3155L20.1752 15.8996H20.1731V16.2724H20.1187V15.8242H20.2003L20.3406 16.2012L20.4809 15.8242H20.5646V16.2724H20.5081Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.565 16.2813H20.5085C20.5043 16.2813 20.5001 16.2771 20.5001 16.2729V15.9462L20.3745 16.275C20.3724 16.2792 20.3703 16.2813 20.3661 16.2813H20.318C20.3138 16.2813 20.3117 16.2792 20.3096 16.275L20.184 15.94V16.2708C20.184 16.275 20.1798 16.2792 20.1756 16.2792H20.1212C20.117 16.2792 20.1128 16.275 20.1128 16.2708V15.8248C20.1128 15.8206 20.117 15.8164 20.1212 15.8164H20.2028C20.207 15.8164 20.2091 15.8185 20.2112 15.8227L20.3431 16.1766L20.475 15.8227C20.4771 15.8185 20.4792 15.8164 20.4833 15.8164H20.565C20.5692 15.8164 20.5734 15.8206 20.5734 15.8248V16.2729C20.5734 16.2771 20.5692 16.2813 20.565 16.2813ZM20.5168 16.2645H20.5545V15.8353H20.4875L20.3494 16.2059C20.3473 16.2101 20.3452 16.2122 20.341 16.2122C20.3368 16.2122 20.3347 16.2101 20.3326 16.2059L20.1944 15.8353H20.1274V16.2645H20.1651V15.9002C20.1651 15.896 20.1693 15.8918 20.1735 15.8918H20.1756C20.1798 15.8918 20.1819 15.8939 20.184 15.8981L20.3221 16.2645H20.3598L20.498 15.8981C20.5022 15.8897 20.5168 15.8918 20.5168 15.9023V16.2645V16.2645Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1255 8.90579C21.8109 10.5894 21.8235 13.362 20.0878 15.0623C18.4023 16.7146 15.6428 16.7313 13.9406 14.9702C12.297 13.2698 12.3222 10.5245 14.0495 8.85134C15.7203 7.23263 18.4358 7.21169 20.1255 8.90579ZM19.9517 9.12986C19.7172 8.89532 19.334 8.89532 19.0974 9.12986L18.5656 9.66175C17.5062 8.96861 16.0867 9.08169 15.1529 9.97795C14.0327 11.0543 14.0202 12.8301 15.1131 13.919C16.2018 15.0037 17.9333 14.9828 18.9969 13.9253C19.9266 13.0018 20.0626 11.5904 19.4073 10.5266L19.9517 9.98214C20.1862 9.74761 20.1862 9.36439 19.9517 9.12986Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2321 11.4186H8.52413C8.19332 11.4186 7.92114 11.6909 7.92114 12.0217C7.92114 12.3547 8.19332 12.6248 8.52413 12.6248H10.6158C10.3268 13.8394 9.23181 14.7419 7.92114 14.7377C6.42413 14.7314 5.18256 13.5232 5.18046 11.9861C5.17837 10.4428 6.44297 9.19684 7.99442 9.22825C8.82144 9.245 9.56262 9.63031 10.0567 10.2271H11.8971C11.2271 8.72149 9.72593 7.67865 8.01117 7.65142C5.60758 7.61373 3.64786 9.53608 3.60808 11.9003C3.5662 14.3482 5.53011 16.2894 7.88973 16.3125C10.3184 16.3376 12.2698 14.3692 12.2677 11.9861C12.2698 11.7935 12.2572 11.605 12.2321 11.4186Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4334_40995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4334_40995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueIcon);
export default __webpack_public_path__ + "static/media/true-icon.0a2822de57408cd1df9cbe5b4e1ec0cc.svg";
export { ForwardRef as ReactComponent };